import type { PlatformUrn } from '@mint-lib/integration-registry';

/**
 * `platform_v2` URNs for every platform this package serves. Sourced from
 * `packages/connections/src/hooks/usePlatformMatcher.ts`'s `MDM_PLATFORMS` map
 * and `packages/connections/src/test-utils/server.ts`'s MDM fixtures for the
 * platforms not referenced by name in `usePlatformMatcher` itself.
 */
export const OMNI_URN = {
  facebook: 'urn:mint:value:platform_v2:facebook',
  adwords: 'urn:mint:value:platform_v2:adwords',
  linkedin: 'urn:mint:value:platform_v2:linkedin_integrated',
  tiktok: 'urn:mint:value:platform_v2:tiktok_integrated',
  dv360: 'urn:mint:value:platform_v2:dv360_integrated',
  bing: 'urn:mint:value:platform_v2:bing_integrated',
  amazon: 'urn:mint:value:platform_v2:amazon_integrated',
  zemanta: 'urn:mint:value:platform_v2:zemanta_integrated',
} as const satisfies Record<string, PlatformUrn>;
